import { render } from "./ShipmentList.vue?vue&type=template&id=d07adb34&ts=true"
import script from "./ShipmentList.vue?vue&type=script&lang=ts"
export * from "./ShipmentList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__